import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "../../../layout/shell.css";

const LANGUAGES = [
  { code: "fr", label: "FR" },
  { code: "en", label: "EN" },
];

const toggleSidebar = () => document.body.classList.toggle("sidebar-main");

const signOut = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("session");
  localStorage.removeItem("lang");
};

const UserToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button
    ref={ref}
    type="button"
    className="app-user-toggle"
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </button>
));

const HeaderStyle1 = () => {
  const { t, i18n } = useTranslation();
  const session = JSON.parse(localStorage.getItem("session")) || {};
  const [language, setLanguage] = useState(
    localStorage.getItem("lang") || "en"
  );

  useEffect(() => {
    if (!localStorage.getItem("lang")) {
      localStorage.setItem("lang", "en");
    }
  }, []);

  const changeLanguage = (code) => {
    setLanguage(code);
    i18n.changeLanguage(code);
    localStorage.setItem("lang", code);
  };

  const mainRole = (session.role || [])[0];

  return (
    <div className="iq-top-navbar app-topbar">
      <button
        type="button"
        className="app-icon-btn"
        onClick={toggleSidebar}
        aria-label={t("Toggle menu")}
      >
        <i className="ri-menu-line" aria-hidden="true"></i>
      </button>

      <div className="app-topbar-actions">
        <div className="app-lang" role="group" aria-label={t("Language")}>
          {LANGUAGES.map(({ code, label }) => (
            <button
              key={code}
              type="button"
              aria-pressed={language === code}
              onClick={() => changeLanguage(code)}
            >
              {label}
            </button>
          ))}
        </div>

        <Dropdown>
          <Dropdown.Toggle as={UserToggle}>
            <span className="app-avatar" aria-hidden="true">
              {(session.name || "?").charAt(0).toUpperCase()}
            </span>
            <span className="app-user-text">
              <strong>{session.name}</strong>
              {mainRole && (
                <small>
                  {t(mainRole.replace(/\b\w/g, (c) => c.toUpperCase()))}
                </small>
              )}
            </span>
            <i className="ri-arrow-down-s-line" aria-hidden="true"></i>
          </Dropdown.Toggle>
          <Dropdown.Menu className="app-user-menu" align="right">
            <div className="app-user-menu-header">
              <strong>{session.name}</strong>
              <small>{session.email}</small>
            </div>
            <Dropdown.Item as={Link} to="/dashboard/profile">
              <i className="ri-user-3-line" aria-hidden="true"></i>
              {t("My Profile")}
            </Dropdown.Item>
            <Dropdown.Item
              as={Link}
              to="/"
              onClick={signOut}
              className="app-user-menu-danger"
            >
              <i className="ri-logout-box-line" aria-hidden="true"></i>
              {t("Sign out")}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default HeaderStyle1;
